import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "C:/Users/Sonish Maharjan/Desktop/texpress/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started-with-texpress"
    }}>{`Getting Started With Texpress`}</h1>
    <p>{`Texpress is a project setup for using `}<strong parentName="p">{`ExpressJS`}</strong>{` with `}<strong parentName="p">{`Typescript`}</strong>{`. It includes a monorepo architecture and uses turborepo for managing the codebase.`}</p>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`Node.js v17 or later`}</li>
      <li parentName="ul">{`Yarn package manager`}</li>
      <li parentName="ul">{`RabbitMQ (For Queue Management)`}</li>
      <li parentName="ul">{`Redis (For Caching and Sessions)`}</li>
      <li parentName="ul">{`PostgreSQL (For Database)`}</li>
    </ul>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`To get started with Texpress, follow these steps:`}</p>
    <ol>
      <li parentName="ol">{`Clone the repository:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`
git clone https://github.com/sonish777/t-express.git

`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Install the dependencies:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`
cd texpress
yarn install

`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Create configuration file `}<inlineCode parentName="li">{`'default.json'`}</inlineCode>{` and copy the contents from `}<inlineCode parentName="li">{`'default.example.json'`}</inlineCode>{` to the new file (inside `}<inlineCode parentName="li">{`config`}</inlineCode>{` directory).`}</li>
    </ol>
    <blockquote>
      <p parentName="blockquote">{`Texpress uses `}<a parentName="p" {...{
          "href": "https://www.npmjs.com/package/config"
        }}>{`config`}</a>{` package for managing configurations`}</p>
    </blockquote>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Create env file `}<inlineCode parentName="li">{`'.env'`}</inlineCode>{` and copy the contents from `}<inlineCode parentName="li">{`'.env.example'`}</inlineCode>{` to the new file in the project root directory.`}</li>
    </ol>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Run migrations`}</li>
    </ol>
    <blockquote>
      <p parentName="blockquote">{`Note: Create a database named `}<strong parentName="p"><inlineCode parentName="strong">{`texpress`}</inlineCode></strong>{` (or the database name you have in previously created config file) in PostgreSQL.`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`
yarn migration:run

`}</code></pre>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Run Seeder`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`
yarn seeder:run

`}</code></pre>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Compile the Javascript files for the CMS application`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`
yarn build:js

`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Note: Use `}<inlineCode parentName="p">{`yarn watch:js`}</inlineCode>{` to compile in watch mode.`}</p>
    </blockquote>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Start the development server`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`
yarn dev

`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`Once you have started the development server, you can access the built-in apps at the following URLs:`}</p>
    <ul>
      <li parentName="ul">{`CMS: `}<a parentName="li" {...{
          "href": "http://localhost:8000/auth/login"
        }}>{`http://localhost:8000/auth/login`}</a><br parentName="li"></br>
        {`Super Admin Login Credentials:`}
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Username:`}</strong>{` `}<a parentName="li" {...{
              "href": "mailto:admin@texpress.com"
            }}>{`admin@texpress.com`}</a></li>
          <li parentName="ul"><strong parentName="li">{`Password:`}</strong>{` Test@1234`}</li>
        </ul>
      </li>
      <li parentName="ul">{`API: `}<a parentName="li" {...{
          "href": "http://localhost:8001/api-docs"
        }}>{`http://localhost:8001/api-docs`}</a></li>
      <li parentName="ul">{`Consumer: `}<a parentName="li" {...{
          "href": "http://localhost:9999/healthz"
        }}>{`http://localhost:9999/healthz`}</a></li>
    </ul>
    <p>{`You can customize the apps and add your own functionality by editing the code in the `}<inlineCode parentName="p">{`'apps'`}</inlineCode>{` and `}<inlineCode parentName="p">{`'packages'`}</inlineCode>{` directory.`}</p>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`If you find a bug or have a feature request, please create an issue on the `}<a parentName="p" {...{
        "href": "https://github.com/sonish777/t-express"
      }}>{`GitHub repository`}</a>{`.`}</p>
    <p>{`To contribute to Texpress, follow these steps:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Fork the repository.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create a new branch with your changes:`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Commit your changes:`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Push your changes to your fork:`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Open a pull request on the main repository.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      